import { IonProgressBar } from '@ionic/react';
import { useBreakpoints } from '../theme/useBreakpoints';
import { Text } from '../components/Text';

export interface IProgressBarProps {
    steps: number;
    currentStep: number;
    disabled?: boolean;
}

export const OnboardingProgressBar: React.FC<IProgressBarProps> = ({ steps, currentStep, disabled }) => {
    const {isAboveBreakpoint} = useBreakpoints();
    return (
        <div style={{display: 'flex', gap: 10, alignItems: 'center'}}>
            <Text disabled={disabled}><span style={{whiteSpace: 'nowrap'}}>{currentStep} of {steps}{isAboveBreakpoint('sm') && ' Completed'}</span></Text>
            <IonProgressBar style={{height: 10, borderRadius: 4}} value={currentStep/steps} />
        </div>
    );
};
